


























import {Component, Prop, Vue} from 'vue-property-decorator'
import {TransactionData, BalanceEntryType} from "@/util/transactionData";
import {currency} from "@/util/formatter";
import spacetime from "spacetime";

@Component
export default class TransactionEntry extends Vue {
    @Prop()
    data!: TransactionData;

    @Prop({
        default: false
    })
    isChecked!: boolean;

    @Prop({
        default: true
    })
    isCheckable!: boolean;

    private get iconName(): string | null {
        if (!this.data.attachment) {
            return null;
        }

        const type = this.data.attachment.type;
        if (type === null) {
            return 'file';
        } else if (type.includes('image')) {
            return 'file-image';
        } else if (type.includes('pdf')) {
            return 'file-pdf';
        } else if (type.includes('sheet')) {
            return 'file-excel';
        } else {
            return 'file';
        }
    }

    private get note(): string {
        if (this.data.note) {
            return this.data.note;
        } else if (!this.data.attachment) {
            return '-';
        } else {
            return '';
        }
    }

    private get isRecurringInstance(): boolean {
        return this.data.recurrentParentId !== null;
    }

    private get formattedAmount(): string {
        return currency(this.data.amount, true);
    }

    private get amountClass(): string {
        return this.data.type === BalanceEntryType.INCOME ? 'text-green' : 'text-red';
    }

    private get formattedDate(): string {
        return spacetime(this.data.date).format('numeric-uk').toString()
    }

    private updateValue(event: InputEvent) {
        if (!this.isCheckable) {
            return;
        }

        const target = event.target as HTMLInputElement;
        const isChecked = target.checked;

        this.$emit('entryCheckStateChanged', this.data.id, isChecked);
    }
}
